// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  firebase: {
    projectId: 'fletesplus',
    appId: '1:3601106778:web:b43118db53d0d395215563',
    storageBucket: 'fletesplus.appspot.com',
    locationId: 'us-central',
    apiKey: 'AIzaSyBWJ3OvcF2qmfYcP2zg3rpqe_OEQMBaUtQ',
    authDomain: 'fletesplus.firebaseapp.com',
    messagingSenderId: '3601106778',
  },
  production: false
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
